import { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useBusinessStore } from '../store/useBusinessStore';
import { supabase } from '../supabaseClient';
import { isMissingExpensesTable } from './useExpenses';

const PAGE = 1000;

const fetchAll = async (build) => {
  const rows = [];
  for (let from = 0; ; from += PAGE) {
    const { data, error } = await build().range(from, from + PAGE - 1);
    if (error) return { error };
    rows.push(...(data || []));
    if (!data || data.length < PAGE) return { data: rows };
  }
};

// Todo lo que necesita la pantalla de caja y resultado: ventas, abonos y gastos del negocio (solo lectura; el dueño o un administrador).
export const useAccounting = () => {
  const { activeBusinessId } = useBusinessStore();
  const [data, setData] = useState({ sales: [], payments: [], expenses: [] });
  const [loading, setLoading] = useState(true);
  const [tableMissing, setTableMissing] = useState(false);

  const load = useCallback(async () => {
    if (!activeBusinessId) { setLoading(false); return; }
    setLoading(true);
    const business = String(activeBusinessId);
    const [sales, payments, expenses] = await Promise.all([
      fetchAll(() => supabase.from('sales').select('id, number, total, paid_total, status, created_at, due_date, customer_id').eq('business_id', business).order('created_at')),
      fetchAll(() => supabase.from('payments').select('id, sale_id, amount, method, paid_at, voided_at').eq('business_id', business).order('paid_at')),
      fetchAll(() => supabase.from('expenses').select('*').eq('business_id', business).order('expense_date'))
    ]);
    if (expenses.error && isMissingExpensesTable(expenses.error)) {
      setTableMissing(true);
      setData({ sales: [], payments: [], expenses: [] });
    } else if (sales.error || payments.error || expenses.error) {
      toast.error('No se pudieron leer los datos de contabilidad.');
      setTableMissing(false);
      setData({ sales: [], payments: [], expenses: [] });
    } else {
      setTableMissing(false);
      setData({ sales: sales.data, payments: payments.data, expenses: expenses.data });
    }
    setLoading(false);
  }, [activeBusinessId]);

  useEffect(() => { load(); }, [load]);

  return { ...data, loading, tableMissing, reload: load };
};
